import { useState } from 'react'

/* styles */
import styles from './_.module.css'

interface Props {
  text: string
  children: React.ReactNode
}

export const Tooltip = ({ text, children }: Props) => {
  const [isVisible, setIsVisible] = useState(false)
  return (
    <div
      className={styles.tooltipContainer}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && (
        <div className={styles.tooltip}>
          {text}
          <span className={styles.tooltipArrow}></span>
        </div>
      )}
    </div>
  )
}
